import { ApiRouts } from '@/src/routes/routes';
import HttpCLient from '@/src/lib/utils/httpClient';
import { ICmsSection, ICountryResponse } from './types';
import { BasicProductDataResponse } from '@/src/types/catalog';
import { getLatAndLongFromCookies } from '@/src/lib/actions/getCookies';

export const CMS_PAGE_COUNT = '10'; // Number of sections per page

export interface MinimalStoreInput {
  id: number;
  branchId: number;
}

type params = {
  pageSize?: string;
  lastSectionIndex?: string;
  pageId?: string;
};

type AllProductsParams = {
  pageId: string;
  Page?: string;
  PageSize?: string;
  OrderType?: string; // بتباصي 3 عشان الـ Gift products
  PriceLowToHigh?: string;
  HaveOffers?: string;
  InStock?: string;
  IsFastDelivery?: string;
  IsNearBy?: string;
  SortBy?: string;
  Direction?: string;
};

class CMCSectionsApi extends HttpCLient {
  getCMSSections = async (params?: params) => {
    try {
      const defaultParams = {
        pageSize: params?.pageSize ? String(params.pageSize) : CMS_PAGE_COUNT,
        lastSectionIndex: params?.lastSectionIndex ? String(params.lastSectionIndex) : '0',
        ...params,
      };
      const response = await this.get<ICmsSection[]>(ApiRouts.cmsSections, defaultParams);
      return response || [];
    } catch (error) {
      return [];
    }
  };

  getCMSSectionsV2 = async (params?: params) => {
    try {
      const defaultParams = {
        pageSize: params?.pageSize ? String(params.pageSize) : CMS_PAGE_COUNT,
        lastSectionIndex: params?.lastSectionIndex ? String(params.lastSectionIndex) : '0',
        ...params,
      };
      const response = await this.get<ICmsSection[]>(ApiRouts.cmsSectionsV2, defaultParams);
      return response || [];
    } catch (error) {
      return [];
    }
  };

  getPageExploer = async ({ pageId, params }: { pageId: string; params?: params }) => {
    try {
      const defaultParams = {
        pageSize: params?.pageSize ? String(params.pageSize) : CMS_PAGE_COUNT,
        lastSectionIndex: params?.lastSectionIndex ? String(params.lastSectionIndex) : '0',

        ...params,
      };

      const response = await this.get<ICmsSection[]>(
        ApiRouts.getExplrePage(pageId),
        defaultParams,
        {},
      );

      return (JSON.parse(JSON.stringify(response)) as ICmsSection[]) || [];
    } catch (error) {
      return [];
    }
  };

  getPageExploerV2 = async ({ pageId, params }: { pageId: string; params?: params }) => {
    try {
      const defaultParams = {
        pageSize: params?.pageSize ? String(params.pageSize) : CMS_PAGE_COUNT,
        lastSectionIndex: params?.lastSectionIndex ? String(params.lastSectionIndex) : '0',

        ...params,
      };

      const response = await this.get<ICmsSection[]>(
        ApiRouts.getExplrePageV2(pageId),
        defaultParams,
        {},
      );

      return (JSON.parse(JSON.stringify(response)) as ICmsSection[]) || [];
    } catch (error) {
      return [];
    }
  };

  // get coutry id from location
  getCountryIdFromLocation = async (): Promise<ICountryResponse> => {
    try {
      const response = await this.get<ICountryResponse>(
        ApiRouts.getCountryIdFromLocation,
        {},
        {
          next: {
            tags: ['locationCountry'],
          },
        },
      );
      return response;
    } catch (error) {
      return {
        id: '0',
        arabicCountryName: '',
        englishCountryName: '',
        currencyCode: '',
      };
    }
  };
  // get the all product in cms

  getAllProductsFromCMS = async (params: AllProductsParams) => {
    try {
      const response = await this.get<BasicProductDataResponse[]>(
        ApiRouts.getAllProductsById,
        { Page: '1', PageSize: '10', ...params },
        {
          next: {
            tags: ['all-products'],
          },
        },
      );

      return response || [];
    } catch (error) {
      return [];
    }
  };

  getLiveStoresMinimal = async ({ data }: { data: MinimalStoreInput[] }) => {
    const cookieCoords = await getLatAndLongFromCookies();
    return await this.post(ApiRouts.getLiveStoreTime, {
      latitude: cookieCoords.latitude,
      longitude: cookieCoords.longitude,
      stores: data.map((s) => ({ storeId: s.id, branchId: s.branchId || s.id })),
    });
  };
}

export const CMSSectionsAPi = new CMCSectionsApi();
